import React from 'react';

/**
 * Funcion que devuelve un componente que representa la fila
 */
const Row = (props) => {
    const { procesos } = props;
    let color = '';
    let objetoFechaInicio = null;
    let objetoFechaFin = null;
    let horaFinProceso = null;
    let fechaFinProceso = null;
    let horaInicioProceso = null;
    let fechaInicioProceso = null;
    let horaInicioProcesoAux = null;
    let horaFinProcesoAux = null;


    let valoresUnicos = procesos;

    valoresUnicos = [... new Set(procesos.map(p => { return p.IdProcesoTraza }))]

    let indexValoresUnicos = valoresUnicos.map(id => { return procesos.findIndex(p => p.IdProcesoTraza == id) })

    let trazasUnicas = indexValoresUnicos.map(id => { return procesos[id] })
 
    const resultado =

        trazasUnicas.map(proceso => {

            color = proceso.ColorResultado == 'AZUL' ? 'procesosAzul' : proceso.ColorResultado == 'ROJO' ? 'procesosRojo' : proceso.ColorResultado == 'AMARILLO' ? 'procesosAmarillo' : 'procesosVerde';

            objetoFechaInicio = proceso.FechaProcesoFin ? new Date(proceso.FechaProceso) : "";
            objetoFechaFin = proceso.FechaProcesoFin ? new Date(proceso.FechaProcesoFin) : "";

            fechaInicioProceso = objetoFechaInicio ? objetoFechaInicio.toLocaleDateString() : "";
            horaInicioProceso = objetoFechaInicio ? objetoFechaInicio.toLocaleTimeString() : "";
            horaInicioProcesoAux = horaInicioProceso ? horaInicioProceso.split(":") : "";
            horaInicioProceso = horaInicioProcesoAux.length > 0 ? horaInicioProcesoAux[0] + ":" + horaInicioProcesoAux[1] : "";

            if (objetoFechaFin) {
                fechaFinProceso = objetoFechaFin.toLocaleDateString();
                horaFinProceso = objetoFechaFin.toLocaleTimeString();
                horaFinProcesoAux = horaFinProceso.split(":")
                horaFinProceso = horaFinProcesoAux[0] + ":" + horaFinProcesoAux[1]
            }
            return(
            <div className='contenedorDatosProceso'>
                <div className={'bottom-separator robotoLabel rowDatosEjecucionProcesos rc-dialog-content ' + color}>
                    <span className='text-left'>{"ID Procesamiento " + proceso.IdProcesoTraza}</span>
                    <span className='text-right pull-right'>{proceso.DescripcionProcesoEstado}</span>
                </div>
                {objetoFechaFin && <div className={'bottom-separator rowDatosEjecucionProcesos contenedorDatosProcesoHoraFin'}>
                    <span className='text-left'>{horaFinProceso}</span>
                    <span className='text-right pull-right'>{"Fin de proceso " + fechaFinProceso}</span>
                </div>}
                {<div className='bottom-separator rowDatosEjecucionProcesos contenedorDatosProceso'>
                    {procesos.map((p) => {
                        if (p.IdProcesoTraza == proceso.IdProcesoTraza && p.CantidadRegistrosPorError)
                            return (
                                <div className='lbl-cierres-importe'>
                                    <div>
                                        {p.CantidadRegistrosPorError + " Reg. con error"}  
                                    </div>
                                    <div>
                                        {p.DescripcionTipoRechazo}
                                    </div>
                                </div>)
                        else return null
                    })
                    }
                </div>}
                {proceso.CantidadRegistrosOk > 0 && <div className='bottom-separator rowDatosEjecucionProcesos contenedorDatosProceso'>
                    <div className='text-right pull-right'>{proceso.CantidadRegistrosOk + ' reg. procesado' + (proceso.CantidadRegistrosOk > 1 ? "s" : "")}</div>
                </div>}

                {<div className='robotoLabel rowDatosEjecucionProcesos contenedorDatosProceso '>
                    <div>
                        <span className='text-left'>{horaInicioProceso}</span>
                        <span className='text-right pull-right'>{"Inicio " + fechaInicioProceso}</span>
                    </div>
                    <div>
                        {proceso.CantidadRegistrosPorError > 0 && <button onClick={() => { props.getErroresProceso(proceso.IdProcesoTraza, proceso.ColorResultado); props.mostrarModal(3, false) }} className="btn btn-cta">Registros con Error/Notas</button>}
                    </div>
                </div>}
            </div>)
        });

        return (
            <div>
                {resultado}
            </div>
        )
}
const DatosEjecucionProceso = (props) => {
    const { datosProcesos, flecha } = props;
    let direccFlecha = 'icono-arriba'
    let claseScroll = '';
    let cantidadTrazasUnicas = [...new Set(datosProcesos.map(p => { return p.IdProcesoTraza }))].length

    //Ordeno el array de mayor a menor
    datosProcesos.sort(function (a, b) {
        if (a.IdProcesoTraza < b.IdProcesoTraza) {
            return 1;
        }
        if (a.IdProcesoTraza > b.IdProcesoTraza) {
            return -1;
        }
        return 0;
    });

    if (!flecha) {
        direccFlecha = 'icono-abajo';
        datosProcesos.reverse();
    }
    if (datosProcesos.length > 1) {
        claseScroll = 'contenedorDatosEjecucionProcesosScroll';
    }

    return (
        <div className='contenedorDatosEjecucionProcesos'>
            <div className='contenedorBotonesDatosEjecucionProcesos'>
                <div>Log</div>
                <div>
                    {cantidadTrazasUnicas > 1 ?
                        <div data-toggle="tooltip" data-title='Invertir Orden' data-placement="right" onClick={() => props.invertirOrdenProc()} className={direccFlecha}></div>
                    :
                        null
                    }
                    <div onClick={() => props.descargarExcel()} className='botonExcel' style={{ float: 'right', position: 'relative', top: '-20px', left: '-10px' }} ></div>
                </div>
            </div>
            <div className={claseScroll}>
                {<Row validarProcesoEnEjecucion={props.validarProcesoEnEjecucion} mostrarModal={props.mostrarModal} getErroresProceso={props.getErroresProceso} procesos={datosProcesos} />}
            </div>
        </div>
    )
}

export default DatosEjecucionProceso;